import ScansGroupedReport from "./ScansGroupedReport";

export default function ScanByDistrict() {
  return (
    <ScansGroupedReport
      title="Scan by District"
      subtitle="Scans grouped by the district of the scanned QR / fuel access's retail outlet."
      dimension="district"
      dropdownLabel="District"
      dropdownPlaceholder="All districts"
      dropdownApiPath="/master/districts"
    />
  );
}
